export const REGIONS = ['header', 'main', 'footer'];

export const slugify = (s) =>
  (s || '')
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s_]+/g, '-')
    .replace(/^-+|-+$/g, '');
